import { errorMessages } from "@/utils/constants";
import Link from "next/link";
import PaymentLogos from "../CopyRight/PaymentLogos";
import styles from "../InstallmentMsgComp/InstallmentMsg.module.scss";
import { openMiniCart } from "@/redux/actions/addToCartAction";

import { useDispatch } from "react-redux";

export default function InstallmentMsg({ showLogo, hasClass }) {
    const dispatch = useDispatch();
    return (
        <>
            <div className={`pwa-link-tag ${styles.wrapper} ${hasClass}`}>
                {showLogo && <div className={styles.logo_wrapper}>
                    <PaymentLogos isInstallmentMsg={true} />
                </div>
                }
                <Link href={`/faq`} className={`text-md-10 text-sm-10 text-xs-10 ${styles.msg_wrapper} display-status`} onClick={()=>dispatch(openMiniCart(false))}>
                    {errorMessages.installmentMsg.paymentMsg} <span className={styles.hover}>Learn more</span>
                </Link>
            </div>
        </>
    )
}